import React from "react";
import { useTranslation } from "react-i18next";

const Eyebrow = ({ children }) => {
  const commentText = "//";
  return (
    <div className="eyebrow" aria-hidden>
      <span>{commentText}</span> {children}
    </div>
  );
};

function TimelineItem({ range, title, org, children }) {
  return (
    <li className="tl__item">
      <div className="tl__content">
        <div className="tl__range">{range}</div>
        <div className="tl__title">{title}</div>
        <div className="tl__org">@ {org}</div>
        {children ? <p className="tl__desc">{children}</p> : null}
      </div>
    </li>
  );
}

function ResumeSection() {
  const { t } = useTranslation();
  
  return (
    <section id="resume" className="card resume">
      <div className="resume__header">
        <Eyebrow>{t('resume.title')}</Eyebrow>
        <h3 className="resume__title">{t('resume.subtitle')}</h3>
      </div>

      <div className="resume__grid">
        <div className="resume__col">
          <h4 className="resume__eyetitle">{t('resume.education.title')}</h4>
          <ul className="tl">
            <TimelineItem
              range={t('resume.education.bachelor.period')}
              title={t('resume.education.bachelor.title')}
              org={t('resume.education.bachelor.school')}
            >
              {t('resume.education.bachelor.description')}
            </TimelineItem>
            <TimelineItem
              range={t('resume.education.vwo.period')}
              title={t('resume.education.vwo.title')}
              org={t('resume.education.vwo.school')}
            >
              {t('resume.education.vwo.description')}
            </TimelineItem>
          </ul>
        </div>

        <div className="resume__col">
          <h4 className="resume__eyetitle">{t('resume.experience.title')}</h4>
          <ul className="tl">
            <TimelineItem
              range={t('resume.experience.frontend.period')}
              title={t('resume.experience.frontend.title')}
              org={t('resume.experience.frontend.company')}
            >
              {t('resume.experience.frontend.description')}
            </TimelineItem>

            <TimelineItem
              range={t('resume.experience.webdev.period')}
              title={t('resume.experience.webdev.title')}
              org={t('resume.experience.webdev.company')}
            >
              {t('resume.experience.webdev.description')}
            </TimelineItem>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default ResumeSection;
